module.exports = __webpack_public_path__ + "static/trade-3-aaecd0bfdcb2e5c8f9e51fda1c02bb14.jpg";